const t={Lg:{width:1024},Md:{width:768},Sm:{width:640},Xl:{width:1280},Xxl:{width:1536},"2xl":{width:1536}};export{t as Breakpoint};
